import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'transform',
  name: 'Transform',
  category: 'utilities',
  description: 'Transform and restructure data items using JavaScript expressions',
  icon: 'Repeat',
  color: 'cyan',
  version: '1.0.0',
  
  group: ['transform'],
  
  defaults: {
    name: 'Transform',
    color: '#06b6d4'
  },
  
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true
    }
  ],
  
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output'
    }
  ],
  
  tags: ['transform', 'convert', 'restructure', 'reshape', 'map', 'expression'],

  metadata: {
    documentation: 'https://docs.n8n.io/data/transforming-data/'
  }
};

export default definition;
